import { z } from 'zod';
import { getMeDtoSchema } from '../getMeDtoSchema';

export const authControllerRegisterUserIfHeIsNotRegisteredYet201Schema = z.lazy(
  () => getMeDtoSchema,
);

export const authControllerRegisterUserIfHeIsNotRegisteredYet400Schema =
  z.union([
    z.object({
      statusCode: z.enum(['400']),
      message: z.string(),
      type: z.enum(['RegistrationWithWrongRole']),
      details: z.enum(['null']).nullable(),
    }),
    z.object({
      statusCode: z.enum(['400']),
      message: z.string(),
      type: z.enum(['InvalidData']),
      details: z.object({
        location: z.enum(['path', 'query', 'body']),
        explanation: z.object({
          issues: z.array(
            z
              .object({
                code: z.enum([
                  'invalid_type',
                  'invalid_literal',
                  'custom',
                  'invalid_union',
                  'invalid_union_discriminator',
                  'invalid_enum_value',
                  'unrecognized_keys',
                  'invalid_arguments',
                  'invalid_return_type',
                  'invalid_date',
                  'invalid_string',
                  'too_small',
                  'too_big',
                  'invalid_intersection_types',
                  'not_multiple_of',
                  'not_finite',
                ]),
                path: z.array(z.union([z.string(), z.number()])),
                message: z.string(),
              })
              .catchall(z.unknown()),
          ),
        }),
      }),
    }),
  ]);

export const authControllerRegisterUserIfHeIsNotRegisteredYet401Schema =
  z.object({
    statusCode: z.enum(['401']),
    message: z.string(),
    type: z.enum(['Authentication']),
    details: z.object({
      reason: z.enum(['InvalidRequest', 'InvalidToken', 'Unauthorized']),
    }),
  });

export const authControllerRegisterUserIfHeIsNotRegisteredYet403Schema =
  z.object({
    statusCode: z.enum(['403']),
    message: z.string(),
    type: z.enum(['Authorization']),
    details: z.object({ reason: z.enum(['InsufficientScope']) }),
  });

export const authControllerRegisterUserIfHeIsNotRegisteredYetMutationRequestSchema =
  z.union([
    z.object({
      firstName: z.string().min(2).max(64),
      lastName: z.string().min(2).max(64),
      email: z.string().email(),
      role: z.enum(['admin']),
    }),
    z.object({
      firstName: z.string().min(2).max(64),
      lastName: z.string().min(2).max(64),
      email: z.string().email(),
      role: z.enum(['student']),
    }),
    z.object({
      firstName: z.string().min(2).max(64),
      lastName: z.string().min(2).max(64),
      email: z.string().email(),
      role: z.enum(['teacher']),
    }),
  ]);

export const authControllerRegisterUserIfHeIsNotRegisteredYetMutationResponseSchema =
  z.lazy(() => getMeDtoSchema);
